import { Breadcrumbs, Button, Card, CardContent, CircularProgress, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from 'axios';
import { FunctionComponent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppShell } from '../components/molecules/app-shell/AppShell';
import { useStore } from '../store';
import { ApiResponse } from '../types';
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    fieldLabel: {
        fontWeight: 600,
        color: theme.palette.text.secondary
    },
    fieldValue: {
        marginBottom: theme.spacing(1.5),
    },
    centerButton: {
        justifyContent: 'center',
        display: 'flex',
    },

}))


type LifeCertificatePageProps = {
}

type LifeCertApiData = {
    fromDate: string,
    toDate: string,
    lifeCertificateStatus: boolean,
    appliedOn: string,
    acknowledgementNo: string,
}

type LifeCertState = {
    loading: boolean,
    error: string,
    certs: Array<LifeCertApiData>
}

export const LifeCertificatePage: FunctionComponent<LifeCertificatePageProps> = () => {
    const classes = useStyles()
    const store = useStore()
    const [lifeCerts, setLifeCerts] = useState<LifeCertState>({ loading: true, error: '', certs: [] })

    useEffect(() => {
        fetchLifeCerts()
    }, []);

    const fetchLifeCerts = () => {
        axios.get<ApiResponse<{ lifeCertificates: LifeCertApiData[] }>>(`/api/pensioner/get-life-certificates`,
            {
                headers: {
                    'Authorization': `Bearer ${store.auth.jwt}`, 'JWT': `Bearer ${store.auth.jwt}`
                }
            })
            .then(
                ({ data: resp }) => {
                    if (resp.status === "success") {
                        const currentYear = new Date().getFullYear();
                        const targetDate = new Date(`${currentYear}-12-31`).toISOString().split('T')[0];
                        const certs: LifeCertApiData[] = resp.data.lifeCertificates.filter(cert => {
                            return cert.toDate === targetDate;
                        })
                        setLifeCerts({ loading: false, error: '', certs: certs })
                    } else {
                        setLifeCerts({ loading: false, error: resp.message, certs: [] })
                    }
                },
                () => { setLifeCerts({ loading: false, error: "Network Error", certs: [] }) }
            )
    }

    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Grid item>
                    <Card className={classes.controlPaper}>
                        <CardContent>
                            <Grid container spacing={3} direction="column" justify="space-around"
                                alignItems="stretch">
                                <Grid item>
                                    <Breadcrumbs>
                                        <Link to="/" className={classes.link}>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                <HomeIcon className={classes.icon} />
                                                Home
                                            </Typography>
                                        </Link>
                                        <Typography gutterBottom variant="h5" component="h2">
                                            Life Certificate (জীবনপ্রমাণ পত্র)
                                        </Typography>
                                    </Breadcrumbs>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                < Grid item>
                    {
                        lifeCerts.loading && <CircularProgress size={68} color="secondary" />
                    }
                    {
                        !lifeCerts.loading && lifeCerts.error &&
                        <>
                            <Alert severity="error">
                                <AlertTitle>Error</AlertTitle>
                                {lifeCerts.error}
                                <Button variant="outlined" color="primary" onClick={fetchLifeCerts}>
                                    Retry
                                </Button>
                            </Alert>
                        </>
                    }
                    {
                        !lifeCerts.loading && !lifeCerts.error && lifeCerts.certs.length === 0 &&
                        <>
                            <Alert severity="warning" style={{ textAlign: "justify" }}>
                                <AlertTitle>Warning</AlertTitle>
                                Life Certificate not submitted yet for the ongoing calender year. Please utilize the Digital Life Certificate facility for Pensioners and Family Pensioners. Refer to the Notice section for more details.
                                <br /><b>(চলমান ক্যালেন্ডার বছরের জন্য জীবন শংসাপত্র এখনও জমা দেওয়া হয়নি। পেনশনভোগী এবং পারিবারিক পেনশনভোগীদের জন্য ডিজিটাল জীবন শংসাপত্র সুবিধাটি ব্যবহার করুন। আরও বিস্তারিত জানার জন্য বিজ্ঞপ্তি বিভাগটি দেখুন।)</b>
                            </Alert>
                        </>
                    }
                </Grid>
                <Grid>

                </Grid>
                {
                    !lifeCerts.loading && !lifeCerts.error && lifeCerts.certs.length > 0 &&
                    <>
                        <Grid item>
                            <Card elevation={3}>
                                <CardContent>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Typography className={classes.fieldLabel}>
                                                Applied on (আবেদন করার তারিখ)
                                            </Typography>
                                            <Typography className={classes.fieldValue}>
                                                {lifeCerts?.certs[0]?.appliedOn ? lifeCerts?.certs[0]?.appliedOn : "NA"}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Typography className={classes.fieldLabel}>
                                                Validity Start Date (বৈধতা শুরুর তারিখ)
                                            </Typography>
                                            <Typography className={classes.fieldValue}>
                                                {/* {lifeCerts?.certs[0]?.from_date.toDateString() ? lifeCerts?.certs[0]?.from_date.toDateString() : "NA"} */}
                                                {lifeCerts.certs[0]?.fromDate ? lifeCerts.certs[0]?.fromDate : "NA"}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Typography className={classes.fieldLabel}>
                                                Validity End Date (বৈধতা শেষ হওয়ার তারিখ)
                                            </Typography>
                                            <Typography className={classes.fieldValue}>
                                                {lifeCerts.certs[0]?.toDate ? lifeCerts.certs[0]?.toDate : "NA"}
                                                {/* {lifeCerts?.certs[0]?.to_date.toDateString() ? lifeCerts?.certs[0]?.to_date.toDateString() : "NA"} */}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Typography className={classes.fieldLabel}>
                                                Life Certificate Status (জীবনপ্রমাণপত্রের বর্তমান স্থীতি)
                                            </Typography>
                                            <Typography className={classes.fieldValue}>
                                                {lifeCerts?.certs[0]?.lifeCertificateStatus ? "YES" : "NO"}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Typography className={classes.fieldLabel}>
                                                Acknowledgement No (প্রাপ্তি স্বীকৃতি নম্বর)
                                            </Typography>
                                            <Typography className={classes.fieldValue} style={{ color: lifeCerts?.certs[0]?.acknowledgementNo?.trim() ? "green" : "red", }}>
                                                {lifeCerts?.certs[0]?.acknowledgementNo?.trim() ? lifeCerts?.certs[0]?.acknowledgementNo : "Life Certificate Under Review"}
                                                {/* {lifeCerts?.certs[0]?.acknowledgement_no ? lifeCerts?.certs[0]?.acknowledgement_no : "NA"} */}
                                            </Typography>

                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item >
                            <Alert severity="info">
                                <AlertTitle style={{ textAlign: "justify" }}>
                                    Please utilize the Digital Life Certificate facility for Pensioners and Family Pensioners. Refer to the Notice section for more details.
                                    <br /><b>(পেনশনভোগী এবং পারিবারিক পেনশনভোগীদের জন্য ডিজিটাল জীবন শংসাপত্র সুবিধাটি ব্যবহার করুন। আরও বিস্তারিত জানার জন্য বিজ্ঞপ্তি বিভাগটি দেখুন।)</b>
                                </AlertTitle>
                            </Alert>
                        </Grid>
                    </>
                }

                <Grid item className={classes.centerButton}>
                    <Link to="/" className={classes.link}>
                        <Button variant='contained' color='primary' size='large'>
                            Back (পিছনে)
                        </Button>
                    </Link>
                </Grid>
            </Grid>
        </AppShell >
    )
}